import gql from 'graphql-tag';

export const GET_ALL_MANAGERS = gql`
  query getAllManagers {
    getAllManagers {
      _id
      managerShortName
      displayName
      assetShortName
    }
  }
`;

export const GET_ALL_MANAGERS_RAW = gql`
  query getAllManagersUnfiltered {
    getAllManagersUnfiltered {
      _id
      managerShortName
      displayName
      assetShortName
    }
  }
`;

export const CREATE_MANAGER = gql`
  mutation createManager($input: ManagerInput!) {
    createManager(input: $input) {
      _id
      managerShortName
      displayName
      assetShortName
    }
  }
`;

export const UPDATE_MANAGER = gql`
  mutation updateManager($_id: String!, $input: ManagerInput!) {
    updateManager(input: $input, _id: $_id) {
      _id
      managerShortName
      displayName
      assetShortName
    }
  }
`;

export const DELETE_MANAGER = gql`
  mutation deleteManager($_id: String!) {
    deleteManager(_id: $_id) {
      _id
    }
  }
`;
